<template lang='pug' src='./custom-home-video.pug'></template>

<script>
export default {
  props: {
    content: {
      type: [Object, Array]
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-video.vue?79cab492